export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-layout-8b50e620c275fad6d55144f56d169233.svg";